import { Step, StepLabel, Stepper } from "@mui/material";
import { stageDescriptors } from "./types";
import { useSettings } from "./tools";
import { FormattedMessage } from "react-intl";

export default function StageStepper() {
    const settings = useSettings();

    return (
        <Stepper activeStep={settings.stage} alternativeLabel sx={{ bgcolor: "transparent", p: 3 }}>
            {stageDescriptors.map((desc) => (
                <Step key={desc.stage}>
                    <StepLabel>
                        <FormattedMessage {...desc.title} />
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}
